<app-navbar-style-one></app-navbar-style-one>
<app-navbar-style-two></app-navbar-style-two>
<div class="privacy-policy-container container">
  <header class="privacy-header">
    <h1 i18n>Privacy Policy</h1>
    <p i18n>Effective Date: 20/02/2025 | Last Updated: 18/02/2025</p>
  </header>
  

  <section class="privacy-content">
    <div class="sub-content">
        <p i18n>Vanuston Intelligence ("we," "our," or "us") is committed to protecting the privacy of our users. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our websites, including medeil.com, medeilplus.com, and other product-related platforms (collectively referred to as "Websites"). By using our Websites, you agree to the terms of this Privacy Policy.</p>
    </div>
    <div class="section-title gradient-text">
        <h2 i18n>1. Information We Collect</h2>
    </div>

    <p i18n>We collect information to provide and improve our services, ensure security, and enhance user experience. The types of information we collect include:</p>

    <h3 i18n>1.1 Personal Information</h3>
    <p i18n>When you interact with our Websites, we may collect personal information, such as:</p>
    <ul>
      <li i18n>Name</li>
      <li i18n>Email address</li>
      <li i18n>Phone number</li>
      <li i18n>Company name</li>
      <li i18n>Billing and payment details (if applicable)</li>
    </ul>

    <h3 i18n>1.2 Non-Personal Information</h3>
    <p i18n>We may collect non-personal information automatically, such as:</p>
    <ul>
        <li i18n>IP address</li>
        <li i18n>Browser type and version</li>
        <li i18n>Device type and operating system</li>
        <li i18n>Pages visited, time spent on pages, and other usage data</li>
        <li i18n>Referring website or search engine</li>
    </ul>

    <h3 i18n>1.3 Cookies and Tracking Technologies</h3>
    <p i18n>We use cookies, web beacons, and similar technologies to collect information about your browsing behavior. This helps us improve our Websites and provide personalized experiences. For more details, see Section 6: Cookies and Tracking Technologies.</p>
     
    
    <div class="section-title gradient-text">
        <h2 i18n>2. How We Use Your Information</h2>
      </div>
      <p i18n>We use the information we collect for the following purposes:</p>
      <ul>
        <li i18n>To provide, operate, and maintain our Websites and services.</li>
        <li i18n>To process transactions and manage your account.</li>
        <li i18n>To communicate with you, including responding to inquiries, sending updates, and providing customer support.</li>
        <li i18n>To improve our Websites, products, and services through analytics and feedback.</li>
        <li i18n>To ensure security and prevent fraud or unauthorized access.</li>
        <li i18n>To comply with legal obligations and enforce our terms and conditions.</li>
      </ul>
      <div class="section-title gradient-text">
        <h2 i18n>3.How We Share Your Information</h2>
      </div>
      <p i18n>We do not sell or rent your personal information to third parties. However, we may share your information in the following circumstances:</p>
      <h3 i18n>3.1 Service Providers</h3>
      <p i18n>We may share your information with trusted third-party service providers who assist us in operating our Websites, processing payments, or delivering services. Examples include:</p>
      <ul>
        <li i18n>Cloud hosting providers (e.g., Microsoft Azure)</li>
        <li i18n>Payment processors</li>
        <li i18n>Analytics providers (e.g., Google Analytics)</li>
      </ul>
      <h3 i18n>3.2 Legal Compliance</h3>
      <p i18n>We may disclose your information if required to do so by law or in response to valid legal requests, such as subpoenas or court orders.</p>
      <h3 i18n>3.3 Business Transfers</h3>
      <p i18n>In the event of a merger, acquisition, or sale of assets, your information may be transferred to the new entity.</p>
      <div class="section-title gradient-text">
        <h2 i18n>4.Data Security</h2>
      </div>
      <p i18n>We take data security seriously and implement industry-standard measures to protect your information. These include:</p>
      <ul>
        <li i18n>Encryption of sensitive data (e.g., AES-256 for data at rest and TLS 1.2/1.3 for data in transit).</li>
        <li i18n>Regular security audits and vulnerability assessments.</li>
        <li i18n>Role-based access controls to limit access to sensitive information</li>
        <li i18n>Secure data storage on Microsoft Azure servers (Central India data center) and SiliconHouse.net dedicated servers.</li>
      </ul>
      <p i18n>While we strive to protect your data, no method of transmission or storage is 100% secure. Therefore, we cannot guarantee absolute security.</p>

      <div class="section-title gradient-text">
        <h2 i18n>5.Data Retention</h2>
      </div>
      <p i18n>We retain your personal information only for as long as necessary to fulfill the purposes outlined in this Privacy Policy or as required by law. Once the retention period expires, we securely delete or anonymize your data.</p>

      <div class="section-title gradient-text">
        <h2 i18n>6.Cookies and Tracking Technologies</h2>
      </div>
      <p i18n>Our Websites use cookies and similar technologies to enhance your browsing experience. These include:</p>
      <h3 i18n>6.1 Types of Cookies</h3>
      <ul>
        <li i18n><strong>Essential Cookies:</strong> Necessary for the operation of our Websites.</li>
        <li i18n><strong>Performance Cookies:</strong> Help us understand how users interact with our Websites.</li>
        <li i18n><strong>Functional Cookies:</strong> Enable personalized features and settings.</li>
        <li i18n><strong>Advertising Cookies:</strong> Used to deliver relevant ads and measure their effectiveness.</li>
      </ul>
      <h3 i18n>6.2 Managing Cookies</h3>
      <p i18n>You can manage or disable cookies through your browser settings. However, disabling cookies may affect the functionality of our Websites.

      </p>
      <div class="section-title gradient-text">
        <h2 i18n>7.Your Rights</h2>
      </div>
      <p i18n>Depending on your location, you may have the following rights regarding your personal information:</p>
      <ul>
        <li i18n><strong>Access:</strong> Request access to the personal information we hold about you.</li>
        <li i18n><strong>Correction:</strong> Request corrections to inaccurate or incomplete information.</li>
        <li i18n><strong>Deletion:</strong> Request the deletion of your personal information, subject to legal obligations.</li>
        <li i18n><strong>Data Portability:</strong> Request a copy of your data in a machine-readable format.</li>
        <li i18n><strong>Opt-Out:</strong> Opt-out of marketing communications or data processing for specific purposes.</li>
      </ul>
      <p i18n>To exercise your rights, please contact us at informus&#64;vanuston.com.</p>
      <div class="section-title gradient-text">
        <h2 i18n>8.Third-Party Links</h2>
      </div>
      <p i18n>Our Websites may contain links to third-party websites. We are not responsible for the privacy practices or content of these websites. We encourage you to review their privacy policies before providing any personal information.</p>
      <div class="section-title gradient-text">
        <h2 i18n>9.International Data Transfers</h2>
      </div>

      <p i18n>If you are accessing our Websites from outside India, please note that your information may be transferred to and processed in India or other countries where our servers or service providers are located. By using our Websites, you consent to such transfers.  </p>
      <div class="section-title gradient-text">
        <h2 i18n>10.Legal Jurisdiction</h2>
      </div>
      <p i18n>All legal disputes related to this Privacy Policy will be handled under the jurisdiction of the High Court of India, Chennai Branch. We comply with applicable Indian laws, including the Information Technology Act, 2000, and its amendments.</p>
      <div class="section-title gradient-text">
        <h2 i18n>11.Updates to This Privacy Policy</h2>
      </div>
      <p i18n>We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. The updated policy will be posted on this page with the "Last Updated" date. We encourage you to review this page periodically.</p>

      <div class="section-title gradient-text">
        <h2 i18n>12.Contact Us</h2>
      </div>
      <p i18n>If you have any questions or concerns, reach out to:</p>
      <p i18n><strong>Vanuston Intelligence Private Limited</strong></p>
      <p i18n>Email: <a href="https://mail.google.com/mail/?view=cm&fs=1&to=informus@vanuston.com">informus&#64;vanuston.com</a></p>
      <p i18n>Website: <a href="https://www.vanuston.com" target="_blank">www.vanuston.com</a></p>
    </section>
  </div>


<app-footer-style-two></app-footer-style-two>